import { isEventActivity } from '@sa/bff-contract';
export var ActivityNames;
(function (ActivityNames) {
    ActivityNames["statusUpdate"] = "va/statusUpdate";
    ActivityNames["general"] = "appevent";
})(ActivityNames || (ActivityNames = {}));
export var BotStatusValues;
(function (BotStatusValues) {
    BotStatusValues["ready"] = "ready";
})(BotStatusValues || (BotStatusValues = {}));
export function isBotStatusReadyActivity(activity) {
    return (activity.type === 'event' &&
        activity.name === ActivityNames.statusUpdate &&
        activity.value.status === BotStatusValues.ready);
}
export function isChannelSwapRequestTimeoutEvent(activity) {
    return isIncomingAppEventActivity(activity, 'channelSwapTimeout');
}
export function isChannelSwapSecurityTokenEvent(activity) {
    return isIncomingAppEventActivity(activity, 'channelSwapSecurityToken');
}
export function isStartClickToCallActivity(activity) {
    const name = 'webchat/startReiClick2CallHandoff';
    return activity.type === 'event' && activity.name === name;
}
export function isVoiceBioTrainingSuccessfulActivity(activity) {
    return isIncomingAppEventActivity(activity, 'vpSuccessTrain');
}
export function isWelcomeActivity(activity) {
    return isIncomingAppEventActivity(activity, 'welcome');
}
export function isStartVoiceBioActivity(activity) {
    return isIncomingAppEventActivity(activity, 'startVoice', 'startVoiceEnrolment');
}
export function isRecordingClosedActivity(activity) {
    return isIncomingAppEventActivity(activity, 'vpFailedRecordingClosed');
}
export function isAcceptVoiceBioOfferActivity(activity) {
    const intentId = 'vpTermsConditions';
    return isActivityWithUserIntentId(activity, intentId);
}
export function isRecordVoiceprintActivity(activity) {
    const intentId = 'recordVoiceprint';
    return isActivityWithUserIntentId(activity, intentId);
}
export function isAcceptVoiceBioTermsActivity(activity) {
    return isIncomingAppEventActivity(activity, 'vpTermsAccept');
}
export function isDeclineVoiceBioTermsActivity(activity) {
    return isIncomingAppEventActivity(activity, 'vpTermsDecline');
}
export function isDeclineVoiceBioOfferActivity(activity) {
    const intentId = 'notNow';
    return isActivityWithUserIntentId(activity, intentId);
}
export function isVoiceBioFailureActivity(activity) {
    return isIncomingAppEventActivity(activity, 'vpFailedGeneric', 'vpFailedInconsistentAudio', 'vpFailedMaxAttempts');
}
export function isVoiceBioAppPermissionErrorActivity(activity) {
    return isIncomingAppEventActivity(activity, 'vpFailedPermissionDenied', 'vpFailedPermissionDeniedAlways');
}
function isIncomingAppEventActivity(activity, ...intentTypes) {
    var _a;
    const name = 'webchat/intent';
    return activity.type === 'event' && activity.name === name && intentTypes.includes((_a = activity.value) === null || _a === void 0 ? void 0 : _a.intent);
}
function isActivityWithUserIntentId(activity, intentId) {
    return isUserIntentActivity(activity) && activity.value.intentId === intentId;
}
export function isUserIntentActivity(activity) {
    return isUserLinkedIntentActivity(activity) || isUserUtteranceActivity(activity);
}
export function isUserLinkedIntentActivity(activity) {
    var _a, _b, _c;
    return (activity.type === 'message' &&
        ((_a = activity.value) === null || _a === void 0 ? void 0 : _a.type) === 'linkedAnswer' &&
        ((_c = (_b = activity.value) === null || _b === void 0 ? void 0 : _b.context) === null || _c === void 0 ? void 0 : _c.interactionId) === 'voiceprint');
}
export function isUserUtteranceActivity(activity) {
    var _a;
    return activity.type === 'message' && ((_a = activity.value) === null || _a === void 0 ? void 0 : _a.type) === 'utterance';
}
export function isUtteranceActivity(activity) {
    return activity.type === 'message' && activity.text !== undefined && !activity.value;
}
export function isCassiusConversationStartedEvent(activity) {
    if (isEventActivity(activity)) {
        const key = 'userContext';
        return activity.name === 'conversationStarted' && key in activity.value;
    }
    return false;
}
//# sourceMappingURL=activities.js.map